import { render } from "./BlogPostView.vue?vue&type=template&id=412f1f3c"
import script from "./BlogPostView.vue?vue&type=script&lang=js"
export * from "./BlogPostView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__